jQuery(function($){
    /**
     * After new items have loaded, discover modals.
     */
    $('.resourcelib-view, .resourcelib-posts').on('resourcelib:postsLoaded', function(){
        eightytwenty.discoverModals();
    });
});
